<div class="common-adm-upload-wrapper p-2 pt-4">
  <form [formGroup]="commonAdmDataUploadGroup">
    <div class="d-flex justify-content-between align-items-center gap-20 flex-wrap">
    <div class="d-flex justify-content-between align-items-center gap-20 flex-wrap">
      <div class="heading">
        <h5>Common ADM Upload</h5>
      </div>
        <!-- File upload component -->

    </div>
      <div class="d-flex justify-content-between align-items-center gap-20 flex-wrap">
        <div class="d-flex justify-content-between align-items-center">
          <label class="mr-2  mt-1">Year:</label>
          <app-year-picker [startYear]="startYear" [currentYear]="currentYear"
            (yearSelected)="handleYearSelected($event)">
          </app-year-picker>
        </div>
      </div>
      </div>
  <div class="d-flex justify-content-start align-items-center gap-20 flex-wrap">
    <!-- <div class="w-100-767">
      <app-gis-select [label]="'Select Layer'" [options]="layerListOption" formControlName="layer"
        (selectionChangecustom)="initValidators($event)">
      </app-gis-select>
    </div> -->
    <div class="w-100-767">
      <app-gis-select [label]="'Geometry Types'" (selectionChangecustom)="onSelectionChange($event)" [options]="geometryTypes" formControlName="geometryTypes">
      </app-gis-select>
    </div>
    <!-- <div class="w-100-767">
      <app-gis-select [label]="'Category'" [options]="geometryCategory" formControlName="geometryCategory"
        (selectionChangecustom)="initValidators($event)">
      </app-gis-select>
    </div> -->
    <div>
      <app-gis-file-upload [getUploadUrl]="getUploadUrl" (afterUpload)="afterUpload()"  [upload_access]="common_adm_upload_access"></app-gis-file-upload>
    </div>
    <div class="loder-btn">
      <button
        mat-mini-fab
        (click)="fetchUploadStatus()"
        matTooltip="Refresh Data"
        class="refresh-btn"
      >
        <mat-icon>sync</mat-icon>
      </button>
    </div>
    </div>
  </form>

    <!-- Data table component -->
    <app-gis-data-table
    (pageChange)="onPageChange($event)"
    [data]="uploadedData"
    [columns]="selectedColumns"
    [buttons]="buttonConfig"
    [totalCount]="totalCount"
    [getStatusClass]="getStatusClass"
  >
  </app-gis-data-table>

  <!-- Loading indicator -->
  <ngx-loading
    [show]="loader"
    [config]="{ backdropBackgroundColour: 'rgba(255,255,255,0.3)' }"
  ></ngx-loading>
</div>
